module.exports = __webpack_public_path__ + "img/andalucia.f8faaf3a.svg";